export default __webpack_public_path__ + "static/media/share_icon.9b00b135.svg";